import React from 'react';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { PersistGate } from 'redux-persist/integration/react';
import { ToastContainer } from 'react-toastify';

import store, { persistor, history } from 'redux/store';

import Routes from 'routes/';
import ImpersonationBoundary from 'components/ImpersonationBoundary';
import routes from 'routes/routes';
import { I18nProvider, ThemeProvider } from '_metronic';

import moment from 'moment';
import 'moment/locale/es';
import 'moment/locale/pt-br';
import 'moment/locale/de';

moment.locale('es');

export default () => (
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <ConnectedRouter history={history}>
        <ThemeProvider>
          <I18nProvider>
            <ImpersonationBoundary>
              <Routes routes={routes} />
              <ToastContainer />
            </ImpersonationBoundary>
          </I18nProvider>
        </ThemeProvider>
      </ConnectedRouter>
    </PersistGate>
  </Provider>
);
